export enum ProjectRole {
  Reviewer = 'Reviewer',
  Annotator = 'Annotator',
}
